var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_296_8804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11133 0.964355V4.22902",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8799 0.964355V4.22902",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40371 13.5318C1.61115 15.3824 3.11535 16.8518 4.97542 16.9414C6.26107 17.0033 7.57442 17.0354 8.99981 17.0354C10.4252 17.0354 11.7385 17.0033 13.0242 16.9414C14.8842 16.8518 16.3885 15.3824 16.5959 13.5318C16.7357 12.2855 16.8502 11.0078 16.8502 9.70621C16.8502 8.40463 16.7357 7.12691 16.5959 5.88064C16.3885 4.03001 14.8842 2.56063 13.0242 2.47105C11.7386 2.40913 10.4252 2.37695 8.99981 2.37695C7.57442 2.37695 6.26107 2.40913 4.97542 2.47105C3.11535 2.56063 1.61115 4.03001 1.40371 5.88064C1.26402 7.12691 1.14941 8.40463 1.14941 9.70621C1.14941 11.0078 1.26402 12.2855 1.40371 13.5318Z",
    stroke: "white",
    strokeWidth: 1.28571
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 7.77783H5.78544",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 11.6348H5.78544",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67871 7.77783H9.32157",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2139 7.77783H12.8567",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67871 11.6348H9.32157",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_296_8804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderSvg);
export default __webpack_public_path__ + "static/media/calenderSvg.42210ea7fdd124287eef6b4a40f8805b.svg";
export { ForwardRef as ReactComponent };